<div class="cf-chart-grid">
  <div class="cf-chart-card">
    <div class="cf-chart-card__header">
      <div class="cf-chart-card__icon cf-chart-card__icon--green">
        <mat-icon>check_circle</mat-icon>
      </div>
      <div class="cf-chart-card__title-wrap">
        <p class="cf-chart-card__title">Gestión de cobros</p>
        <p class="cf-chart-card__sub">Cobrado vs. pendiente</p>
      </div>
    </div>

    <div class="cf-chart-canvas-wrap">
      <canvas baseChart
        [type]="chartType"
        [data]="chartData"
        [options]="chartOptions"
        (chartHover)="chartHovered($event)"
        (chartClick)="chartClicked($event)">
      </canvas>
    </div>
  </div>

  <div class="cf-chart-card">
    <div class="cf-chart-card__header">
      <div class="cf-chart-card__icon cf-chart-card__icon--blue">
        <mat-icon>event</mat-icon>
      </div>
      <div class="cf-chart-card__title-wrap">
        <p class="cf-chart-card__title">Detalle por periodo</p>
        <p class="cf-chart-card__sub">Filtra por meses</p>
      </div>
      <div class="cf-chart-card__header-actions">
        <mat-form-field subscriptSizing="dynamic" style="width:190px;">
          <mat-label>Meses</mat-label>
          <mat-select [formControl]="monthControl" multiple
            (selectionChange)="onChangeMonth($event)" #monthSelect>
            <mat-checkbox (change)='onSelectAll($event)' class="ps-3" [(ngModel)]="allMonthsSelected">
              Todos
            </mat-checkbox>
            <mat-select-trigger>
              <span *ngIf="allMonthsSelected" class="example-additional-selection">
                Todos
              </span>
              <span *ngIf="!allMonthsSelected" class="example-additional-selection">
                {{ getSelectedMonthsNames() }}
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let card of monthList; trackBy: trackByIndex" [value]="card.number">{{card.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="rs-stat-group">
      <button class="rs-stat rs-stat--green" (click)="openDialog(false, true, false, false)">
        <span class="rs-stat__label">
          <mat-icon>check_circle</mat-icon> Cobrado
        </span>
        <span class="rs-stat__value">{{ totalIncomesPaid | number:'1.2-2' }} €</span>
        <span class="rs-stat__hint">Ver detalle</span>
      </button>
      <app-help key='Resumen3'></app-help>

      <button class="rs-stat rs-stat--orange" (click)="openDialog(false, false, false, true)">
        <span class="rs-stat__label">
          <mat-icon>schedule</mat-icon> No cobrado
        </span>
        <span class="rs-stat__value">{{ totalIncomesUnPaid | number:'1.2-2' }} €</span>
        <span class="rs-stat__hint">Ver detalle</span>
      </button>
      <app-help key='Resumen4'></app-help>

      <div class="rs-stat rs-stat--total">
        <span class="rs-stat__label">Total</span>
        <span class="rs-stat__value">{{ totalFormated((totalIncomesPaid + totalIncomesUnPaid)) | number:'1.2-2' }} €</span>
      </div>
    </div>
  </div>
</div>
